/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable @typescript-eslint/indent */
/* eslint-disable react/jsx-indent-props */
/* eslint-disable max-len */
/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import { Config } from 'utils/config/config';

const Term = () => {
  const PDF_URL = `${Config.PEARMD_ASSETS_URL}/legal/terms/terms-of-service-hcp.pdf`;

  return (
    <iframe title="Terms of Service" src={PDF_URL} width="100%" height="100%">
      This browser does not support the embeded PDF.{' '}
      <a target="_blank" rel="noreferrer noopener" href={PDF_URL}>
        Download the PDF.
      </a>
    </iframe>
  );
};

export default Term;
/* eslint-enable */
